/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateSeen.defs.js'
export * as $defs from './updateSeen.defs.js'
